import { Switch, SwitchProps, styled } from '@mui/material';
import { forwardRef } from 'react';
import { GREY, PRIMARY } from '../../constants/color';

const UnstyledSwitch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => (
  <Switch ref={ref} focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
));

const IOSSwitch = styled(UnstyledSwitch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: 'white',
      '& + .MuiSwitch-track': {
        backgroundColor: PRIMARY,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: PRIMARY,
      border: '6px solid white',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: GREY,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default IOSSwitch;
